// REF: https://gist.github.com/michancio/10105690
export default () =>
  navigator.userAgent.indexOf('Safari') > -1 &&
  navigator.userAgent.indexOf('Chrome') <= -1;
